import React, { CSSProperties, FC, useEffect, useState } from 'react';
import { Select } from 'antd';
import { useConnection } from '../../connection/Application';

export type EnumLoaderProps = {
  enum: string;
  style?: CSSProperties;
  onChange?: (value: number) => void;
  value?: number;
};

const EnumLoader: FC<EnumLoaderProps> = (props) => {
  const { value, onChange } = props;
  const [items, setItems] = useState<{ id: number; value: string }[]>([]);
  const [fetching, setFetching] = useState<boolean>(false);

  const connection = useConnection();

  useEffect(() => {
    setFetching(true);
    connection
      .get(`select-values/${props.enum}`)
      .then((response) => {
        setItems(response);
      })
      .finally(() => setFetching(false));
  }, [connection, props.enum]);
  return (
    <Select
      showSearch
      loading={fetching}
      style={props.style}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option?.props?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      filterSort={(optionA, optionB) =>
        optionA?.props?.children.toLowerCase().localeCompare(optionB?.props?.children.toLowerCase())
      }
      onSelect={(item) => onChange?.(item)}
      value={value}>
      {items.map((item: { id: number; value: string }) => (
        <Select.Option key={item.id} value={item.id}>
          {item.value}
        </Select.Option>
      ))}
    </Select>
  );
};

export default EnumLoader;
